module.exports = __webpack_public_path__ + "img/world_wide.png";